<script>
import Collisions from 'collisions'
import updateTick from '@/mixins/update-tick.js'

export default {
  mixins: [
    updateTick
  ],

  props: {
    components: {
      type: Object
    }
  },

  data () {
    return {
      system: new Collisions(),
      bodies: {}
    }
  },

  computed: {
    collideComponents () {
      return Object.keys(this.components).reduce((acc, uid) => {
        const components = this.components[uid]

        components
          .filter((c) => c.kind === 'collide')
          .forEach((c) => acc[c.uid] = { ...c, entityUid: uid })

        return acc
      }, {})
    }
  },

  render () {
    return undefined
  },

  methods: {
    update () {
      // Update collision body parameters
      Object.keys(this.collideComponents).forEach((uid) => {
        const component = this.collideComponents[uid]
        if (!component) return

        const fullComponent = this.components[component.entityUid].find((c) => c.uid === component.uid)
        fullComponent.result = undefined
        fullComponent.collision = undefined
        // this.$store.dispatch('setComponent', { entityUid: component.entityUid, component: fullComponent })

        const followComponent = this.components[component.entityUid].find((c) => c.uid === component.followUid)
        if (!followComponent) return

        const ref = this.bodies[uid]
        if (!ref) return

        ref.body.x = followComponent.x
        ref.body.y = followComponent.y
      })

      // Update collision system
      this.system.update()

      // Resolve collision
      Object.keys(this.collideComponents).forEach((uid) => {
        const ref = this.bodies[uid]
        if (!ref) return

        const component = this.collideComponents[uid]
        if (!component) return

        if (component.test) this.test(ref)
      })
    },

    test (ref) {
      const result = this.system.createResult()
      const component = this.components[ref.entityUid].find((c) => c.uid === ref.componentUid)
      const potentials = ref.body.potentials()

      for (const other of potentials) {
        if (component.details) {
          if (ref.body.collides(other, result)) {
            const otherRef = this.bodies[other.uid]

            component.result = result
            component.collision = {
              entityUid: ref.entityUid,
              componentUid: ref.componentUid,
              otherEntityUid: otherRef.entityUid,
              otherComponentUid: otherRef.componentUid
            }
            this.$store.dispatch('setComponent', { entityUid: ref.entityUid, component })
          }
        } else {
          if (ref.body.collides(other)) {
            const otherRef = this.bodies[other.uid]

            component.collision = {
              entityUid: ref.entityUid,
              componentUid: ref.componentUid,
              otherEntityUid: otherRef.entityUid,
              otherComponentUid: otherRef.componentUid
            }
            this.$store.dispatch('setComponent', { entityUid: ref.entityUid, component })
          }
        }
      }
    },

    addBody (body, componentUid, entityUid) {
      body.uid = componentUid

      if (this.bodies[componentUid]) return

      this.$set(this.bodies, componentUid, {
        body,
        entityUid,
        componentUid
      })
    },

    deleteBody (uid) {
      this.system.remove(this.bodies[uid].body)
      this.$delete(this.bodies, uid)
    }
  },

  watch: {
    collideComponents: {
      handler (components) {
        // Remove orphaned bodies
        Object.keys(this.bodies).forEach((uid) => {
          if (!components[uid]) this.deleteBody(uid)
        })

        // Add new bodies
        Object.keys(components).forEach((uid) => {
          if (!this.bodies[uid]) {
            let body
            const component = components[uid]

            switch (component.shape) {
              case 'circle':
                body = this.system.createCircle(0, 0, component.radius)
                break
              case 'polygon':
                body = this.system.createPolygon(0, 0, component.points)
                break
              case 'line':
                body = this.system.createPolygon(0, 0, [
                  [ component.from.x, component.from.y ],
                  [ component.to.x, component.to.y ]
                ])
                break
              case 'point':
                body = this.system.createPoint(0, 0)
                break
            }

            this.addBody(body, uid, component.entityUid)
          }
        })
      },
      immediate: true
    }
  }
}
</script>
